module.exports = __webpack_public_path__ + "static/OneDotExt.9453b5c7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotExt.eot
// module id = 753
// module chunks = 114276838955818